import {
  ArrowLeftOutlined,
  CloseCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tabs,
  notification,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import DataGrid from 'components/theme_components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DisplayFramework from 'DisplayFramework';
import ExportXLS from 'components/theme_components/ExportXLS';
import FilterInput from 'components/theme_components/FiltreInputSFS';
import FinanceDetails from './ContractDetailComponents/FinContractDetails';
import { FormInstance } from 'antd/lib';
import HeroTitle from 'components/theme_components/HeroTitle';
import ResetButtonAction from 'components/theme_components/ResetButtonAction';
import Title from 'antd/es/typography/Title';
import TitlePage from 'components/theme_components/Title';
import VehicleDetails from './ContractDetailComponents/AssetDetails';
import { getFinClientInvoiceByAssetID } from 'services/clientInvoice';
import { getFinConElementByAssetID } from 'services/finassets';
import { getContractHistory, getFinContractById } from 'services/fincontract';
import isNil from 'lodash/isNil';
import { use } from 'i18next';
import { useForm } from 'antd/lib/form/Form';
import { useQuery } from 'react-query';
import _, { groupBy } from 'lodash';
import { conElementToElement } from '../PropDetail/conElementToElement';
import moment from 'moment';

const { Option } = Select;

export type ContractDetailProps = {
  form?: FormInstance;
  onPrev?: () => void;
  color?: string;
  tpauthid?: number;
  clientName?: string;
};

const ContractDetail = (props: ContractDetailProps) => {
  const [form] = useForm();
  const { id } = useParams<{ id: string }>();
  const numericId = id ? Number(id) : undefined;
  const navigate = useNavigate();

  const transactionColumns: DataGridColDef[] = [
    { dataIndex: 'tprefence', key: 'tprefence' },
    { dataIndex: 'tpname', key: 'tpname' },
    { dataIndex: 'transactiontype', key: 'transactiontype' },
    { dataIndex: 'transactiondate', key: 'transactiondate' , render: (value)=> moment(value).format('DD/MM/YYYY')},
    { dataIndex: 'transactionduedate', key: 'transactionduedate' , render: (value)=> moment(value).format('DD/MM/YYYY')},
    {
      dataIndex: 'transactionamount',
      key: 'transactionamount',
    },
    {
      dataIndex: 'transactionbankaccount',
      key: 'transactionbankaccount',
    },
  ];

  // Fetch transaction data from getFinClientInvoiceByAssetID
  const {
    data: transactionData,
    isLoading: transactionLoading,
    error: transactionError,
  } = useQuery(
    ['getContractHistory', id],
    () =>
      getContractHistory({ ctrid: Number(id) })
        .then((res) => {
          return res.data || [];
        })
        .catch((err) => {
          notification.error({
            message: err?.error,
            duration: 5000,
            description: err?.message,
          });
        }),
    { enabled: !isNil(id) }
  );

  const ctrid = id;
  const { data, isLoading, error } = useQuery(
    ['getFinContractById', ctrid],
    () =>
      getFinContractById({ ctrid: Number(ctrid) })
        .then((res) => {
          if (res.code === '403') {
            window.history.replaceState(null, '', '/403');
            window.location.reload();
          }
          return res.data;
        })
        .catch((err) => {
          notification.error({
            message: err?.error,
            duration: 5000,
            description: err?.message,
          });
        }),
    { enabled: !isNil(ctrid) }
  );

  // if (data) {
  //   console.log('Fetched contract data:', data);
  // }

  // if (transactionData) {
  //   console.log('Fetched transaction data:', transactionData);
  // }

  const { data: finComElements } = useQuery(
    ['getFinConElementByAssetID', id],
    () =>
      getFinConElementByAssetID({ assetid: Number(id) }).then((res) => {

        return res.list || [];
      }),
    {
      enabled: !isNil(id),
    }
  );

  // useEffect(() => {
  //   console.log('Fetched data:', finComElements);
  // }, [finComElements]);

  const historyColumns = [
    { title: 'RRDI', dataIndex: 'tpreference', key: 'tpreference' },
    { title: 'Point de vente', dataIndex: 'tpname', key: 'tpname' },
    {
      title: 'Activité',
      dataIndex: 'prcode',
      render: () => data?.prcode || '-',
    },
    {
      title: 'date de début de contrat',
      dataIndex: 'startdate',
      key: 'startdate',
    },
    { title: 'Fin contrat', dataIndex: 'endate', key: 'endate' },
    {
      title: 'Numéro contrat',
      dataIndex: 'ctreference',
      key: 'ctreference',
    },

    {
      title: 'Statut',
      dataIndex: 'ctstatuslabel',
      key: 'ctstatuslabel',
      render: (text: string, record: any) => {
        let status = data?.ctstatuslabel || '-';
        let color = '';
        let bgColor = '';
        let displayText = status;
        if (status === 'Activé') {
          color = '#52c41a';
          bgColor = 'rgba(82,196,26,0.15)';
        } else if (status === 'Annulé') {
          color = '#ff4d4f';
          bgColor = 'rgba(255,77,79,0.15)';
        } else {
          color = '#d9d9d9';
          bgColor = 'rgba(217,217,217,0.15)';
        }
        return (
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              background: bgColor,
              borderRadius: '20px',
              padding: '2px 12px',
              fontWeight: 500,
            }}
          >
            {displayText}
          </span>
        );
      },
    },
  ];
  const handleFilter = (values: any) => {
    console.log('Filter values:', values);
  };

  const handleReset = () => {
    form.resetFields();
  };

  // useEffect(() => {
  //   console.log('ContractDetail mounted');
  //   return () => {
  //     console.log('ContractDetail unmounted');
  //   };
  // }, []);


  useEffect(() => {
    if (data) {

      const {
        FIN = [],
        SERV = [],
        FEES = [],
        COMM = [],
        FINSERV = [],
        //      } = groupBy(data.conElements || [], 'ctetype');
      } = groupBy(
        conElementToElement(data.conElements, data.offer) || [],
        'ctetype'
      );

      let conElements: any[] = data?.conElements;

      let _selectedCteId = 1;
      let _selectedElement: any = conElements?.find(
        (e: any) =>
          e.ctetype === 'FIN' &&
          (e.ctestatus === 'PREFIN' || e.ctestatus === 'ACTIVE')
      );

      if (_selectedElement !== undefined) {
        _selectedCteId = _selectedElement?.cteid;
      } else {
        let _elem: any[] = conElements?.filter((e: any) => e.ctetype === 'FIN');

        _selectedCteId = _.maxBy(_elem, 'cteid')?.cteid;
      }


      form.setFieldsValue({
        elements: {
          COMM,
          FEES,
          FIN,
          FINSERV,
          SERV,
        },
        selectedElement: _selectedCteId
      })
    }
  }, [ctrid, data]);


  const filterConfig = [
    {
      key: 'transactionType',
      type: 'select',
      placeholder: 'Transaction Type',
    },
    {
      key: 'clientType',
      type: 'input',
      render: () => <Input suffix={<SearchOutlined />} />,
    },
    {
      key: 'dueDate',
      label: 'Due Date',
      type: 'date',
    },
    {
      key: 'paymentDate',
      label: 'Payment Date',
      type: 'date',
    },
  ];

  const showContractDetail = false;
  const isCompleted = false;
  const prevIcon = <ArrowLeftOutlined />;
  const back = () => navigate(-1);

  return (
    <DisplayFramework.Provider pagcode="contractdetails" entity="CONTRACT">
      <Form form={form} className="bg-color-green">
        {!showContractDetail ? (
          <>
            <div className="bg-color-green">
              {/* <TitlePage
                level={2}
                titleProps={contractData?.clientname}
                title=''
                bgColor="green"
                noTitleOverlay
                onPrev={!isCompleted ? back : back}
              /> */}
              <HeroTitle
                form={form}
                color="green"
                display
                prevTab={`/thirdparty-sfs/${data?.tpidclient}/CONC?tab=6`}
                titleDisplay={`VIN - ${data?.assets != null && data?.assets?.length > 0
                    ? data.assets[0]?.chassisno ?? ''
                    : ''
                  }`}
              />
            </div>

            <div className="ut-title-page no-after">
              <Row gutter={16} className="">
                <Col span={12}>
                  <VehicleDetails data={data} />
                </Col>
                <Col span={12}>
                  <FinanceDetails
                    form={form}
                    data={data}
                    loading={isLoading}
                    ctrid={data?.ctrid ?? 0}
                  />
                </Col>
              </Row>

              <Tabs defaultActiveKey="1" className="custom-tabs">
                <Tabs.TabPane tab="Historique du véhicule" key="1">
                  {/* <Row>
                    <Form
                      form={form}
                      onFinish={handleFilter}
                      layout="inline"
                      className="custom-filter-form specific-form"
                      style={{
                        marginTop: '3rem',
                        marginBottom: '0rem',
                        width: '100%',
                      }}
                    >
                      <Row
                        gutter={20}
                        style={{ width: '100%' }}
                        className="d-flex justify-center"
                      >
                        {filterConfig.map((config, index) => (
                          <Col span={5} key={config.key}>
                            <Form.Item
                              name={config.key}
                              className={`mb-0 ${index === 0 ? 'first-filter-item' : ''
                                }`}
                              style={{
                                width: '100%',
                                ...(index === 0 ? { marginTop: '0' } : {}),
                              }}
                            >
                              <FilterInput
                                config={{
                                  ...config,
                                  label: config.label || '',
                                }}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                          </Col>
                        ))}
                        <Col span={2}>
                          <ResetButtonAction
                            comcode="Reset"
                            className="ut-reset-btn-orange"
                            type="default"
                          ></ResetButtonAction>
                        </Col>
                      </Row>
                    </Form>
                  </Row> */}
                  <Row justify="end" className="mt-4">
                    <Col span={5} className="d-flex justify-end align-center">
                      <ExportXLS
                        data={data?.conElements || []}
                        filename="outsanding-activities"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-6 no-border" justify="center">
                    <Col span={24}>
                      <DataGrid
                        columns={historyColumns}
                        dataSource={finComElements}
                        size="large"
                        rowKey="key"
                        pagination={false}
                      />
                    </Col>
                  </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Historique de transaction" key="2">
                  {/* <Row>
                    <Col span={24}>
                      <Form
                        form={form}
                        onFinish={handleFilter}
                        layout="inline"
                        className="custom-filter-form specific-form"
                        style={{
                          marginTop: '3rem',
                          marginBottom: '0rem',
                          width: '100%',
                        }}
                      >
                        <Row
                          gutter={20}
                          style={{ width: '100%' }}
                          className="d-flex justify-center"
                        >
                          {filterConfig.map((config, index) => (
                            <Col span={5} key={config.key}>
                              <Form.Item
                                name={config.key}
                                className={`mb-0 ${index === 0 ? 'first-filter-item' : ''
                                  }`}
                                style={{
                                  width: '100%',
                                  ...(index === 0 ? { marginTop: '0' } : {}),
                                }}
                              >
                                <FilterInput
                                  config={{
                                    ...config,
                                    label: config.label || '',
                                  }}
                                  style={{ width: '100%' }}
                                />
                              </Form.Item>
                            </Col>
                          ))}
                          <Col span={2}>
                            <ResetButtonAction
                              comcode="Reset"
                              className="ut-reset-btn-orange"
                              type="default"
                            ></ResetButtonAction>
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row> */}
                  <Row justify="end" className="mt-4">
                    <Col span={5} className="d-flex justify-end align-center">
                      <ExportXLS
                        data={
                          Array.isArray(transactionData) ? transactionData : []
                        }
                        filename="outsanding-activities"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-6 no-border" justify="center">
                    <Col span={24}>
                      <DataGrid
                        columns={transactionColumns}
                        dataSource={
                          Array.isArray(transactionData) ? transactionData : []
                        }
                        size="large"
                        rowKey="key"
                        pagination={false}
                      />
                    </Col>
                  </Row>
                </Tabs.TabPane>
              </Tabs>
            </div>
          </>
        ) : null}
      </Form>
    </DisplayFramework.Provider>
  );
};

export default ContractDetail;
